var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 10.5V19.365C11.795 19.7025 11.6825 20.0625 11.4238 20.2987C11.3197 20.403 11.1961 20.4858 11.06 20.5422C10.9239 20.5987 10.778 20.6277 10.6307 20.6277C10.4833 20.6277 10.3374 20.5987 10.2013 20.5422C10.0652 20.4858 9.9416 20.403 9.83753 20.2987L7.57628 18.0375C7.45358 17.9176 7.36028 17.7709 7.30369 17.6089C7.24709 17.4469 7.22872 17.274 7.25003 17.1038V10.5H7.21628L0.736275 2.1975C0.553585 1.96297 0.471151 1.66567 0.506987 1.37055C0.542823 1.07543 0.694015 0.80649 0.927526 0.6225C1.14128 0.465 1.37753 0.375 1.62503 0.375H17.375C17.6225 0.375 17.8588 0.465 18.0725 0.6225C18.306 0.80649 18.4572 1.07543 18.4931 1.37055C18.5289 1.66567 18.4465 1.96297 18.2638 2.1975L11.7838 10.5H11.75Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter.b15483cb842c5b1d161b342434f3a6aa.svg";